import { TCreateGameCategoryVisibleForm, TTypeOfCreateGameCategoryModalWindow } from './createGameCategoryContext';
import { IItemForGetShortInfo, TLanguageIDs, ICreateGameCategory, IGameCategoryTranslation } from 'types';

export enum CreateGameCategoryActionTypes {
	CHANGE_VISIBLE_FORM = 'CHANGE_VISIBLE_FORM',
	CHANGE_NAME = 'CHANGE_NAME',
	SET_FETCHED_LANGUAGES = 'SET_FETCHED_LANGUAGES',
	SET_IDs_LANGUAGES = 'SET_IDs_LANGUAGES',
	SET_DATA_FOR_SUBMIT = 'SET_DATA_FOR_SUBMIT',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
	SET_TRANSLATION_TAB = 'SET_TRANSLATION_TAB',
	SET_TRANSLATION_FIELDS = 'SET_TRANSLATION_FIELDS',
	CHANGE_TRANSLATION = 'CHANGE_TRANSLATION',
	RESET_FIELDS = 'RESET_FIELDS',
}

interface IChangeVisibleForm {
	type: CreateGameCategoryActionTypes.CHANGE_VISIBLE_FORM;
	payload: {
		visibleForm: TCreateGameCategoryVisibleForm;
	};
}

interface IChangeName {
	type: CreateGameCategoryActionTypes.CHANGE_NAME;
	payload: {
		name: string;
	};
}

interface ISetFetchedLanguages {
	type: CreateGameCategoryActionTypes.SET_FETCHED_LANGUAGES;
	payload: {
		languages: IItemForGetShortInfo[];
	};
}

interface ISetIDsLanguages {
	type: CreateGameCategoryActionTypes.SET_IDs_LANGUAGES;
	payload: {
		IDsLanguages: TLanguageIDs[];
	};
}

interface ISetDataForSubmit {
	type: CreateGameCategoryActionTypes.SET_DATA_FOR_SUBMIT;
	payload: {
		data: ICreateGameCategory | null;
	};
}

interface IChangeTypeOfModalWindow {
	type: CreateGameCategoryActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: TTypeOfCreateGameCategoryModalWindow;
	};
}

interface ISetTranslationTab {
	type: CreateGameCategoryActionTypes.SET_TRANSLATION_TAB;
	payload: {
		translationTab: TLanguageIDs | null;
	};
}

interface ISetTranslationFields {
	type: CreateGameCategoryActionTypes.SET_TRANSLATION_FIELDS;
	payload: {
		updatedTranslations: IGameCategoryTranslation[];
	};
}

interface IChangeTranslation {
	type: CreateGameCategoryActionTypes.CHANGE_TRANSLATION;
	payload: {
		updatedTranslations: IGameCategoryTranslation[];
	};
}

interface IResetSelectedControls {
	type: CreateGameCategoryActionTypes.RESET_FIELDS;
}

export type TCreateGameCategoryAction =
	| IChangeVisibleForm
	| IChangeName
	| ISetFetchedLanguages
	| ISetIDsLanguages
	| ISetDataForSubmit
	| IChangeTypeOfModalWindow
	| ISetTranslationTab
	| ISetTranslationFields
	| IChangeTranslation
	| IResetSelectedControls;
